// CREATE_ASSIGN PROCESS
export const CREATE_PROCESS_ASSIGN_STYLE_MASTER_REQUEST = 'CREATE_PROCESS_ASSIGN_STYLE_MASTER_REQUEST';
export const CREATE_PROCESS_ASSIGN_STYLE_MASTER_SUCCESS = 'CREATE_PROCESS_ASSIGN_STYLE_MASTER_SUCCESS';
export const CREATE_PROCESS_ASSIGN_STYLE_MASTER_FAILURE = 'CREATE_PROCESS_ASSIGN_STYLE_MASTER_FAILURE';

// FETCH ALL ASSIGN PROCESS
export const FETCH_PROCESS_ASSIGN_STYLE_MASTER_REQUEST = 'FETCH_PROCESS_ASSIGN_STYLE_MASTER_REQUEST';
export const FETCH_PROCESS_ASSIGN_STYLE_MASTER_SUCCESS = 'FETCH_PROCESS_ASSIGN_STYLE_MASTER_SUCCESS';
export const FETCH_PROCESS_ASSIGN_STYLE_MASTER_FAILURE = 'FETCH_PROCESS_ASSIGN_STYLE_MASTER_FAILURE';

// DELETE PROCESS
export const DELETE_PROCESS_ASSIGN_STYLE_MASTER_REQUEST = 'DELETE_PROCESS_ASSIGN_STYLE_MASTER_REQUEST';
export const DELETE_PROCESS_ASSIGN_STYLE_MASTER_SUCCESS = 'DELETE_PROCESS_ASSIGN_STYLE_MASTER_SUCCESS';
export const DELETE_PROCESS_ASSIGN_STYLE_MASTER_FAILURE = 'DELETE_PROCESS_ASSIGN_STYLE_MASTER_FAILURE';

// UPDATE PROCESS_ASSIGN_STYLE_MASTER
export const UPDATE_PROCESS_ASSIGN_STYLE_MASTER_REQUEST = 'UPDATE_PROCESS_ASSIGN_STYLE_MASTER_REQUEST';
export const UPDATE_PROCESS_ASSIGN_STYLE_MASTER_SUCCESS = 'UPDATE_PROCESS_ASSIGN_STYLE_MASTER_SUCCESS';
export const UPDATE_PROCESS_ASSIGN_STYLE_MASTER_FAILURE = 'UPDATE_PROCESS_ASSIGN_STYLE_MASTER_FAILURE';

export const UPDATE_PROCESS_ASSIGN_STYLE_MASTER_REQUEST_NEW = 'UPDATE_PROCESS_ASSIGN_STYLE_MASTER_REQUEST_NEW';
export const UPDATE_PROCESS_ASSIGN_STYLE_MASTER_SUCCESS_NEW = 'UPDATE_PROCESS_ASSIGN_STYLE_MASTER_SUCCESS_NEW';
export const UPDATE_PROCESS_ASSIGN_STYLE_MASTER_FAILURE_NEW = 'UPDATE_PROCESS_ASSIGN_STYLE_MASTER_FAILURE_NEW';

// FETCH SINGLE STATE OF PROCESS_ASSIGN_STYLE_MASTER
export const FETCH_SINGLE_PROCESS_ASSIGN_STYLE_MASTER_REQUEST = 'FETCH_SINGLE_PROCESS_ASSIGN_STYLE_MASTER_REQUEST';
export const FETCH_SINGLE_PROCESS_ASSIGN_STYLE_MASTER_SUCCESS = 'FETCH_SINGLE_PROCESS_ASSIGN_STYLE_MASTER_SUCCESS';
export const FETCH_SINGLE_PROCESS_ASSIGN_STYLE_MASTER_FAILURE = 'FETCH_SINGLE_PROCESS_ASSIGN_STYLE_MASTER_FAILURE';

export const RESET_PROCESS_ASSIGN_STYLE_MASTER_INFO = 'RESET_PROCESS_ASSIGN_STYLE_MASTER_INFO';

export const CREATE_PROCESS_ASSIGN_STYLE_MASTER_FORM = 'CREATE_PROCESS_ASSIGN_STYLE_MASTER_FORM';

export const UPDATE_PROCESS_ASSIGN_STYLE_MASTER_FORM = 'UPDATE_PROCESS_ASSIGN_STYLE_MASTER_FORM';

export const CREATE_PROCESS_ASSIGN_STYLE_MASTER_COSTKG_PROCESS_REQUEST = 'CREATE_PROCESS_ASSIGN_STYLE_MASTER_COSTKG_PROCESS_REQUEST';
export const CREATE_PROCESS_ASSIGN_STYLE_MASTER_COSTKG_PROCESS_SUCCESS = 'CREATE_PROCESS_ASSIGN_STYLE_MASTER_COSTKG_PROCESS_SUCCESS';
export const CREATE_PROCESS_ASSIGN_STYLE_MASTER_COSTKG_PROCESS_FAILURE = 'CREATE_PROCESS_ASSIGN_STYLE_MASTER_COSTKG_PROCESS_FAILURE';

export const CREATE_STYLE_IN_PROGRESS_REQUEST = 'CREATE_STYLE_IN_PROGRESS_REQUEST';
export const CREATE_STYLE_IN_PROGRESS_SUCCESS = 'CREATE_STYLE_IN_PROGRESS_SUCCESS';
export const CREATE_STYLE_IN_PROGRESS_FAILURE = 'CREATE_STYLE_IN_PROGRESS_FAILURE';